export class SowRetainedHoursStats {
  sowId!: number
  totalHours!: number
  usedHours!: number
  remainingHours!: number
  scopeStats!: { scopeId: number; totalHours: number }[]
}
